var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SlideShowSection'),_c('EnrollmentSection'),_c('CoursesSection'),_c('CalendarSection'),_c('ArticlesSection'),_c('GalleriesSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }